export type ContentType = "article" | "video";
export type SortType = "latest" | "hot";

interface FilterBarProps {
  tags: string[];
  activeTags: string[];
  contentType: ContentType;
  sort: SortType;
  resultCount: number;
  onToggleType: (type: ContentType) => void;
  onChangeSort: (sort: SortType) => void;
  onToggleTag: (tag: string) => void;
  onReset: () => void;
}

export default function FilterBar({
  tags,
  activeTags,
  contentType,
  sort,
  resultCount,
  onToggleType,
  onChangeSort,
  onToggleTag,
  onReset,
}: FilterBarProps) {
  const hasFilter = activeTags.length > 0;

  return (
    <div className="rounded-lg border border-background-200 bg-background-50">
      <div className="flex flex-col gap-3 border-b border-background-200 p-3 md:flex-row md:items-center md:justify-between md:p-4">
        <div className="flex items-center gap-1 rounded-full bg-background-100 p-1">
          {[
            { key: "article" as ContentType, label: "文章", icon: "ri-file-text-line" },
            { key: "video" as ContentType, label: "视频", icon: "ri-play-circle-line" },
          ].map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={() => onToggleType(item.key)}
              className={`flex flex-1 cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors md:flex-none ${
                contentType === item.key
                  ? "bg-background-50 text-primary-600"
                  : "text-foreground-500 hover:text-foreground-800"
              }`}
            >
              <i className={`${item.icon} text-base`} />
              {item.label}
            </button>
          ))}
        </div>

        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-1">
            {[
              { key: "latest" as SortType, label: "最新" },
              { key: "hot" as SortType, label: "最热" },
            ].map((item) => (
              <button
                key={item.key}
                type="button"
                onClick={() => onChangeSort(item.key)}
                className={`cursor-pointer whitespace-nowrap rounded-md px-3 py-1.5 text-xs transition-colors ${
                  sort === item.key
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-500 hover:bg-background-100 hover:text-foreground-800"
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
          <span className="whitespace-nowrap text-xs text-foreground-400">共 {resultCount} 条结果</span>
        </div>
      </div>

      <div className="p-3 md:p-4">
        <div className="mb-2 flex items-center justify-between">
          <p className="flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-price-tag-3-line text-primary-500" />
            标签筛选
            <span className="text-foreground-300">（可多选）</span>
          </p>
          {hasFilter ? (
            <button
              type="button"
              onClick={onReset}
              className="cursor-pointer whitespace-nowrap text-xs text-primary-600 hover:text-primary-700"
            >
              清除筛选
            </button>
          ) : null}
        </div>
        <div className="flex flex-wrap gap-2">
          {tags.map((tag) => {
            const active = activeTags.includes(tag);
            return (
              <button
                key={tag}
                type="button"
                onClick={() => onToggleTag(tag)}
                className={`cursor-pointer whitespace-nowrap rounded-full border px-3 py-1 text-xs transition-colors ${
                  active
                    ? "border-primary-500 bg-primary-500 text-background-50"
                    : "border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
                }`}
              >
                {active ? <i className="ri-check-line mr-1" /> : null}
                {tag}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}